export const RESET_MEDIA_INFO = (prefix) => `RESET_${prefix}_MEDIA_INFO`;

export const SET_MEDIA_INFO = (prefix) => `SET_${prefix}_MEDIA_INFO`;

export const UPDATE_MEDIA_INFO = (prefix) => `UPDATE_${prefix}_MEDIA_INFO`;

export const SET_IS_LOADING = (prefix) => `SET_${prefix}_MEDIA_INFO_IS_LOADING`;
